/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type DeleteGooseGameQuestLogMutationVariables = Types.Exact<{
  id: Types.Scalars["Float"];
}>;

export type DeleteGooseGameQuestLogMutation = {
  deleteGooseGameQuestLog: Pick<
    Types.GooseGameQuestLog,
    "id" | "quest_id" | "created_at"
  >;
};

export const DeleteGooseGameQuestLogDocument = gql`
  mutation DeleteGooseGameQuestLog($id: Float!) {
    deleteGooseGameQuestLog(id: $id) {
      id
      quest_id
      created_at
    }
  }
`;

/**
 * __useDeleteGooseGameQuestLogMutation__
 *
 * To run a mutation, you first call `useDeleteGooseGameQuestLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGooseGameQuestLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGooseGameQuestLogMutation, { data, loading, error }] = useDeleteGooseGameQuestLogMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGooseGameQuestLogMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteGooseGameQuestLogMutation,
    DeleteGooseGameQuestLogMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    DeleteGooseGameQuestLogMutation,
    DeleteGooseGameQuestLogMutationVariables
  >(DeleteGooseGameQuestLogDocument, baseOptions);
}
export type DeleteGooseGameQuestLogMutationHookResult = ReturnType<
  typeof useDeleteGooseGameQuestLogMutation
>;
export type DeleteGooseGameQuestLogMutationResult =
  ApolloReactCommon.MutationResult<DeleteGooseGameQuestLogMutation>;
export type DeleteGooseGameQuestLogMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    DeleteGooseGameQuestLogMutation,
    DeleteGooseGameQuestLogMutationVariables
  >;
